import React from 'react';
import { Quote } from 'lucide-react';

export const Testimonials: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-white border-t border-slate-100 overflow-hidden">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Mobile: Horizontal Scroll / Desktop: Grid */}
        <div className="flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-2 gap-6 pb-8 md:pb-0 -mx-4 px-4 md:mx-0 md:px-0 scrollbar-hide">
          
          <div className="relative p-6 bg-slate-50/50 md:bg-transparent rounded-2xl md:rounded-none min-w-[85vw] md:min-w-0 snap-center border border-slate-100 md:border-none">
            <Quote size={40} className="text-brand-100 absolute top-4 left-4 -z-10 md:-top-4 md:-left-2" />
            <p className="text-slate-800 text-lg leading-relaxed mb-6 font-light italic md:not-italic">
              "Ik zag erg op tegen het gedoe met verzekeraars. Het was een verademing dat dit mij volledig uit handen werd genomen. De rust die dat gaf was onbetaalbaar."
            </p>
            <div className="flex flex-col">
              <span className="font-medium text-slate-900">Sanne de Vries</span>
              <span className="text-sm text-slate-500">Verkeersongeval</span>
            </div>
          </div>

          <div className="relative p-6 bg-slate-50/50 md:bg-transparent rounded-2xl md:rounded-none min-w-[85vw] md:min-w-0 snap-center border border-slate-100 md:border-none">
             <Quote size={40} className="text-brand-100 absolute top-4 left-4 -z-10 md:-top-4 md:-left-2" />
            <p className="text-slate-800 text-lg leading-relaxed mb-6 font-light italic md:not-italic">
              "Ik wist niet dat ik recht had op een vergoeding na mijn val op het werk. Dankzij de jurist is alles keurig geregeld zonder dat het mij iets heeft gekost."
            </p>
            <div className="flex flex-col">
              <span className="font-medium text-slate-900">Mark H.</span>
              <span className="text-sm text-slate-500">Bedrijfsongeval</span>
            </div>
          </div>
          
          {/* Spacer for mobile scroll end */}
          <div className="w-1 md:hidden shrink-0"></div>
        </div>
        
        {/* Mobile Swipe Indicator hint could go here, but context usually implies it */}
      </div>
    </section>
  );
};